module.exports = __webpack_public_path__ + "media/images/icons/tag-red-af29548591ed6632a4349782837b0b85.svg";